export const namecolorMap: Record<string, string> = {
  red: '#D32F2F'
}

export const pipe = {
  time: (second: number | null | undefined, showHour?: boolean) => {
    second = second || 0
    if (second === 0 || second === Infinity || second.toString() === 'NaN') {
      return '00:00'
    }
    const add0 = (num: number) => (num < 10 ? '0' + num : '' + num)
    const hour = Math.floor(second / 3600)
    const min = Math.floor((second - hour * 3600) / 60)
    const sec = Math.floor(second - hour * 3600 - min * 60)
    if (showHour) {
      return (hour > 0 ? [hour, min, sec] : [min, sec]).map(add0).join(':')
    } else {
      return [hour * 60 + min, sec].map(add0).join(':')
    }
  },
  date: (date: string | number) => {
    if (typeof date === 'number') {
      date = date * 1000
    }
    const previousTime = new Date(date)
    const currentTime = new Date().getTime()
    const duration = currentTime - previousTime.getTime()
    const seconds = Math.floor(duration / 1000)
    if (seconds < 60) return '刚刚' // 秒数变化较快，不准确，故1分钟内使用“刚刚”较合适
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return minutes + '分钟前'
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return hours + '小时前' // 精确到小时即可
    if (previousTime.getFullYear() == new Date().getFullYear()) {
      return previousTime.getMonth() + 1 + '-' + previousTime.getDate()
    }

    return (
      previousTime.getFullYear() +
      '-' +
      (previousTime.getMonth() + 1) +
      '-' +
      previousTime.getDate()
    )
  },
  exactDate: (date: string | number) => {
    if (typeof date === 'number') {
      date = date * 1000
    }
    const time = new Date(date)
    return (
      time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate()
    )
  },
  exactDateWithTime: (date: string | number) => {
    if (typeof date === 'number') {
      date = date * 1000
    }
    const time = new Date(date)
    return (
      time.getFullYear() +
      '-' +
      (time.getMonth() + 1) +
      '-' +
      time.getDate() +
      ' ' +
      time.getHours() +
      ':' +
      time.getMinutes() +
      ':' +
      time.getSeconds()
    )
  },
  exactTime: (date: string | number) => {
    const add0 = (num: number) => (num < 10 ? '0' + num : '' + num)
    if (typeof date === 'number') {
      date = date * 1000
    }
    const time = new Date(date)
    return [time.getHours(), time.getMinutes(), time.getSeconds()]
      .map(add0)
      .join(':')
  },
  recentDate: (date: string | number) => {
    if (typeof date === 'number') {
      date = date * 1000
    }
    const previousTime = new Date(date)
    const currentTime = new Date().getTime()
    const duration = currentTime - previousTime.getTime()
    const seconds = Math.floor(duration / 1000)
    if (seconds <= 0) return '刚刚'
    if (seconds < 60) return seconds + '秒前'
    const minutes = Math.floor(seconds / 60)
    if (minutes < 60) return minutes + '分钟前'
    const hours = Math.floor(minutes / 60)
    if (hours < 24) return hours + '小时前'
  },
  num: (number?: number) => {
    if (!number) return 0
    if (number < 10000) return number
    return (Math.floor(number / 1000) / 10).toFixed(1) + '万'
  },
  favoriteFolderStatus(status: number) {
    switch (status) {
      case 1:
        return '公开'
      case 2:
        return '私密'
      case 3:
        return '隐藏'
    }
  },
  size(byte: number | null | undefined, mb?: boolean) {
    if (!byte) return '0 B'
    if (mb) {
      byte = byte * 1024 * 1024
    }
    if (byte < 1024) {
      return byte + ' B'
    } else if (byte < 1024 * 1024) {
      return (byte / 1024).toFixed(2) + ' KB'
    } else if (byte < 1024 * 1024 * 1024) {
      return (byte / (1024 * 1024)).toFixed(2) + ' MB'
    } else if (byte < 1024 * 1024 * 1024 * 1024) {
      return (byte / (1024 * 1024 * 1024)).toFixed(2) + ' GB'
    } else {
      return (byte / (1024 * 1024 * 1024 * 1024)).toFixed(2) + ' TB'
    }
  },
  namecolor: (color: string) => {
    return namecolorMap[color] || color
  }
}
